import * as React from 'react';
import styled from 'styled-components';

const ProgressCircularWrapper = styled.div`
  .progress-circular {
    width: 60px;
    height: 60px;
    line-height: 60px;
    background: none;
    box-shadow: none;
    position: relative;

    &--small {
      width: 36px;
      height: 36px;
      line-height: 36px;

      .progress-circular-value {
        font-size: 0.625rem;
      }
    }

    &--md {
      width: 136px;
      height: 136px;
      line-height: 136px;

      .progress-circular-value {
        font-size: 14px;
      }

      &::after {
        border-width: 20px !important;
      }

      .progress-circular-bar {
        border-width: 20px;
      }
    }

    &--clickable {
      cursor: pointer;
    }

    &::after {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 5px solid #f1f5fa;
      top: 0;
      left: 0;
      box-sizing: border-box;
    }

    & > span {
      position: absolute;
      width: 50%;
      height: 100%;
      overflow: hidden;
      top: 0;
      z-index: 1;
    }

    &-bar {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background: none;
      border-width: 5px;
      border-color: #32c9d3;
      border-style: solid;
    }

    &-left {
      left: 0;

      & .progress-circular-bar {
        left: 100%;
        border-top-right-radius: 80px;
        border-bottom-right-radius: 80px;
        border-left: 0;
        transform-origin: center left;
        transform: rotate(${props => props.value100}deg);
      }
    }

    &-right {
      right: 0;

      & .progress-circular-bar {
        left: -100%;
        border-top-left-radius: 80px;
        border-bottom-left-radius: 80px;
        border-right: 0;
        transform-origin: center right;
        transform: rotate(${props => props.value50}deg);
      }
    }

    &-value {
      position: absolute;
      width: 100%;
      height: 100%;
      font-size: 0.75rem;
      font-weight: 700;
      color: #5d6a86;
      text-align: center;
      z-index: 2;
    }
  }
`;

export function ProgressCircular(props) {
  const { valueNow = 100, time, className, onClick, style } = props;

  const [value50, setValue50] = React.useState(0);

  const [value100, setValue100] = React.useState(0);

  React.useEffect(() => {
    if (valueNow <= 50) {
      setValue50((valueNow * 360) / 100);
      setValue100(0);
    } else if (valueNow > 50 && valueNow <= 100) {
      setValue50(180);
      setValue100((valueNow * 360) / 100 - 180);
    } else {
      setValue50(180);
      setValue100(180);
    }

    return () => {
      setValue50(180);
      setValue100(180);
    };
  }, [valueNow]);

  return (
    <ProgressCircularWrapper
      value100={value100}
      value50={value50}
    >
      <div
        className={className ? `progress-circular ${className}` : 'progress-circular'}
        onClick={onClick ? onClick : null}
        style={style}
      >
        <span className="progress-circular-left">
          <span className="progress-circular-bar" />
        </span>
        <span className="progress-circular-right">
          <span className="progress-circular-bar" />
        </span>
        <div className="progress-circular-value">{time ? time : <span>{valueNow}%</span>}</div>
      </div>
    </ProgressCircularWrapper>
  );
}
